var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0081 24.2769H27.5142V37.593H42.0081V24.2769Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6299 22.5227H28.2345C27.13 22.5227 26.2345 23.4181 26.2345 24.5227V39.8425C26.2345 40.9471 27.13 41.8425 28.2345 41.8425H41.6299C42.7345 41.8425 43.6299 40.9471 43.6299 39.8425V24.5227C43.6299 23.4181 42.7345 22.5227 41.6299 22.5227Z",
    fill: "#59A5EE",
    stroke: "#4C5B66",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10362 25.4849L19.499 25.4849C20.6036 25.4849 21.499 24.5894 21.499 23.4849L21.499 8.16504C21.499 7.06046 20.6036 6.16504 19.499 6.16504L6.10362 6.16503C4.99905 6.16503 4.10362 7.06046 4.10362 8.16503L4.10362 23.4849C4.10362 24.5894 4.99905 25.4849 6.10362 25.4849Z",
    fill: "#6BB1F3",
    stroke: "#4C5B66",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6299 6.16504H28.2345C27.13 6.16504 26.2345 7.06047 26.2345 8.16504V15.7872C26.2345 16.8917 27.13 17.7872 28.2345 17.7872H41.6299C42.7345 17.7872 43.6299 16.8917 43.6299 15.7872V8.16504C43.6299 7.06047 42.7345 6.16504 41.6299 6.16504Z",
    fill: "#59A5EE",
    stroke: "#4C5B66",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10362 41.8425L19.499 41.8425C20.6036 41.8425 21.499 40.9471 21.499 39.8425L21.499 32.2204C21.499 31.1158 20.6036 30.2204 19.499 30.2204L6.10362 30.2204C4.99905 30.2204 4.10362 31.1158 4.10362 32.2204L4.10362 39.8425C4.10362 40.9471 4.99905 41.8425 6.10362 41.8425Z",
    fill: "#59A5EE",
    stroke: "#4C5B66",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.129649408cc77e049f2a3abd8ac52189.svg";
export { ForwardRef as ReactComponent };